import Vue from 'vue'
import { GlobalMixin } from '~/mixins/GlobalMixin'
import { Helper } from '~/mixins/Helper'

Vue.mixin(GlobalMixin)
Vue.mixin(Helper)



// WEBPACK FOOTER //
// ./plugins/_globalMixins.js